var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RequestUpdated',{attrs:{"request-type":"overtime","notification":_vm.notification,"active-notification":_vm.activeNotification},on:{"show-more-details":_vm.showMoreDetails}})
}
var staticRenderFns = []

export { render, staticRenderFns }